import Swiper from 'swiper';
import { Navigation, Virtual, A11y } from 'swiper/modules';
import 'swiper/css';

const defaultOptions = {
	modules: [Navigation, Virtual, A11y],

	direction: 'horizontal',
	loop: false,
	slidesPerView: 1,
	spaceBetween: 16,
	grabCursor: true,

	breakpoints: {
		601: {
			slidesPerView: 2,
		},
		1201: {
			slidesPerView: 4,
		},
	},

	navigation: {
		nextEl: '.swiper-alt-navigation .swiper-button-next',
		prevEl: '.swiper-alt-navigation .swiper-button-prev',
	},
	a11y: {
        prevSlideMessage: 'Forrige slide',
        nextSlideMessage: 'Næste slide',
    },
};

function debounce(fn, delay) {
    let timer;
    return function (...args) {
        clearTimeout(timer);
        timer = setTimeout(() => fn.apply(this, args), delay);
    };
}

document.querySelectorAll('.blocklist-component-carousel:not(.has-filters, .blocklist-component-carousel-gallery) .swiper').forEach(function (el) {
	var swiper = new Swiper(el, defaultOptions);
});

function getEudTitle(swiperEl) {
	var wrapper = swiperEl.closest('.gallery-wrapper');
	return wrapper ? wrapper.querySelector('.eud-theme-title') : null;
}

var isEudTheme = document.body.classList.contains('eud-theme');
var isMobile = window.innerWidth <= 1024;

// Reveal each carousel — title, cards, and the gallery wordmark — once the
// section scrolls into view. Sections are styled as visible by default;
// `js-reveal` opts them into the hidden start state, so nothing ever gets stuck
// invisible when JS is unavailable.
(function revealCarousels() {
	var sections = document.querySelectorAll('.blocklist-component-carousel');
	if (!sections.length) return;

	if (!('IntersectionObserver' in window)) {
		sections.forEach(function (section) {
			section.classList.add('js-reveal', 'is-revealed');
		});
		return;
	}

	// threshold 0 + a negative bottom margin fires when the top edge of the
	// section crosses 80% of the viewport height, so the reveal starts at the
	// same visual moment regardless of how tall the section renders. A
	// fraction-based threshold would fire late on tall sections, such as the
	// gallery on mobile.
	var observer = new IntersectionObserver(function (entries) {
		entries.forEach(function (entry) {
			if (!entry.isIntersecting) return;
			entry.target.classList.add('is-revealed');
			observer.unobserve(entry.target);
		});
	}, { threshold: 0, rootMargin: '0px 0px -20% 0px' });

	sections.forEach(function (section) {
		section.classList.add('js-reveal');
		observer.observe(section);
	});
})();

document.querySelectorAll('.blocklist-component-carousel-gallery .swiper').forEach(function (el) {
	var config = {
		modules: [Navigation, Virtual, A11y],

		direction: 'horizontal',
		loop: false,
		slidesPerView: 1,
		spaceBetween: 16,
		grabCursor: true,
		slidesOffsetBefore: 0,

		breakpoints: {
			601: {
				slidesPerView: 2,
			},
			993: {
				slidesPerView: 2,
				slidesOffsetBefore: isEudTheme ? 300 : 0,
			},
			1201: {
				slidesPerView: 3,
				slidesOffsetBefore: isEudTheme ? 300 : 0,
			}
		},

		navigation: {
			nextEl: '.swiper-alt-navigation .swiper-button-next',
			prevEl: '.swiper-alt-navigation .swiper-button-prev',
		},
		a11y: {
			prevSlideMessage: 'Forrige slide',
			nextSlideMessage: 'Næste slide',
		},

		on: {
			slideChange: function () {
				var title = getEudTitle(el);
				if (!title) return;
				var isMobile = window.innerWidth <= 768;
				
				if (isMobile || this.activeIndex === 0) {
					title.classList.remove('behind');
				} else {
					title.classList.add('behind');
				}
			}
		}
	};

	var swiper = new Swiper(el, config);

	if (isEudTheme) {
		window.addEventListener('resize', debounce(function () {
			swiper.destroy(true, true);
			swiper = new Swiper(el, config);
		}, 250));
	}
});

const categoryOptions = {
	modules: [Navigation, Virtual, A11y],
	direction: 'horizontal',
	loop: false,
	slidesPerView: 'auto',
	spaceBetween: 16,
	grabCursor: true,
	nested: true,

	navigation: {
		nextEl: '.swiper-navigation .swiper-button-next',
		prevEl: '.swiper-navigation .swiper-button-prev',
	},
	a11y: {
		prevSlideMessage: 'Forrige slide',
		nextSlideMessage: 'Næste slide',
	},
};

document.querySelectorAll('.blocklist-component-carousel.has-filters').forEach(function (el) {
	let swiperOuter = new Swiper(el.querySelector('.swiper.outer'), defaultOptions),
		swiperInner = new Swiper(el.querySelector('.swiper.inner'), categoryOptions),
		buttons 	= el.querySelectorAll('.categories button'),
		cards 		= el.querySelectorAll('.swiper-slide.carousel-card-education');
	
	buttons.forEach(function (button) {
		button.addEventListener('click', function (e) {

			buttons.forEach(button => button.classList.remove('active'));
			this.classList.add('active');

			let categoryId = this.getAttribute('data-category');

			cards.forEach(function (card) {
				if (card.getAttribute('data-category') === categoryId) {
					card.style.display = 'block';
					card.classList.add('updated');
				} else {
					card.style.display = 'none';
				}
			});

			swiperOuter.update();
		});
	});

	function handleOverflow(){
		let filterWrapper = el.querySelector('.swiper.inner .swiper-wrapper');
		if (filterWrapper.scrollWidth > filterWrapper.clientWidth) {
			filterWrapper.parentNode.classList.add('overflowing');
		}else {
			filterWrapper.parentNode.classList.remove('overflowing');
		}
	}

	handleOverflow()
	swiperInner.on('resize', function() {
		handleOverflow()
	});

	let paramString = window.location.search;
	let match = paramString.match(/category=([^&]*)/);
	let categoryId = match ? match[1] : null;

	if (categoryId) {
		let button = el.querySelector(`button[data-category="${categoryId}"]`);
		if (button) {
			button.click();
			let index = Array.from(buttons).findIndex(b => b.getAttribute('data-category') === categoryId);
			swiperInner.slideTo(index);
		}
		else {
			buttons[0].click();
		}
	}
});